import { DeleteWordsTuple } from 'ui/PowerTable/PowerTable.types';

export const ASSIGNED_STUDENTS_DELETE_WORDS: DeleteWordsTuple = [
    'студентов',
    'студента',
    undefined
];

export const ASSIGNED_STUDENTS_DELETE_CORE_WORD = 'снять с курса';
